import gql from 'graphql-tag';

const NEW_GET_SECURITY_CONFIGURATION = gql`
  query {
    getAppSecurityConfiguration {
      configurationId
      sessionInactiveDuration
      sessionInactiveUnit
      sessionTrustEnable
      ipWhitelistEnable
      ipWhitelistRange
      technicianPasswordPolicy
      requesterPasswordPolicy
      companyUserPasswordPolicy
      clientUserPasswordPolicy
      technCustomPwdPolicy {
        length
        isAlphaNumeric
        isMixCaseWithSpecialChar
        checkEmailMatch
        checkPrevPasswordMatchCount
        allowedFailureAtempt
        passwordExpiryDays
      }
      reqstrCustomPwdPolicy {
        length
        isAlphaNumeric
        isMixCaseWithSpecialChar
        checkEmailMatch
        checkPrevPasswordMatchCount
        allowedFailureAtempt
        passwordExpiryDays
      }
      companyUserCustomPasswordPolicy {
        length
        isAlphaNumeric
        isMixCaseWithSpecialChar
        checkEmailMatch
        checkPrevPasswordMatchCount
        allowedFailureAtempt
        passwordExpiryDays
      }
      clientUserCustomPasswordPolicy {
        length
        isAlphaNumeric
        isMixCaseWithSpecialChar
        checkEmailMatch
        checkPrevPasswordMatchCount
        allowedFailureAtempt
        passwordExpiryDays
      }
      enforceTfa
    }
  }
`;
const GET_SECURITY_CONFIGURATION = gql`
  query {
    getAppSecurityConfiguration {
      configurationId
      ssoType
      idpDetail {
        certificate
        idpLoginUrl
        postLogoutUrl
      }
      spDetail {
        spConsumerUrl
      }
      sessionInactiveDuration
      sessionInactiveUnit
      sessionTrustEnable
      ipWhitelistEnable
      ipWhitelistRange
      technicianPasswordPolicy
      requesterPasswordPolicy
      companyUserPasswordPolicy
      clientUserPasswordPolicy
      technCustomPwdPolicy {
        length
        isAlphaNumeric
        isMixCaseWithSpecialChar
        checkEmailMatch
        checkPrevPasswordMatchCount
        allowedFailureAtempt
        passwordExpiryDays
      }
      reqstrCustomPwdPolicy {
        length
        isAlphaNumeric
        isMixCaseWithSpecialChar
        checkEmailMatch
        checkPrevPasswordMatchCount
        allowedFailureAtempt
        passwordExpiryDays
      }
      companyUserCustomPasswordPolicy {
        length
        isAlphaNumeric
        isMixCaseWithSpecialChar
        checkEmailMatch
        checkPrevPasswordMatchCount
        allowedFailureAtempt
        passwordExpiryDays
      }
      clientUserCustomPasswordPolicy {
        length
        isAlphaNumeric
        isMixCaseWithSpecialChar
        checkEmailMatch
        checkPrevPasswordMatchCount
        allowedFailureAtempt
        passwordExpiryDays
      }
      enforceTfa
    }
  }
`;

const GET_USER_TFA_DETAIL = gql`
  query {
    getCurrentUserTfaDetail {
      tfaType
      authenticatorSecretKey
    }
  }
`;

const GET_DEFAULT_PASSWORD_POLICIES = gql`
  query {
    getDefaultPasswordPoliciesConfig {
      passwordPolicyType
      length
      isAlphaNumeric
      isMixCaseWithSpecialChar
      checkEmailMatch
      checkPrevPasswordMatchCount
      allowedFailureAtempt
      passwordExpiryDays
    }
  }
`;

const GET_ALL_SECURITY_CONFIG = gql`
  query getAllSsoConfigurations($scope: String!, $userType: String!) {
    getAllSsoConfigurations(scope: $scope, userType: $userType) {
      acsUrl
      entityId
      ssoConfigurations {
        configId
        name
        userType
        scope
        clients {
          accountId
          name
        }
        enabled
        entityId
        createdBy {
          userId
          name
        }
        updatedBy {
          userId
          name
        }
        certificate
        idpLoginUrl
        idpLogoutUrl
      }
    }
  }
`;

const GET_SECURITY_CONFIG = gql`
  query($configurationId: ID!) {
    getSsoConfiguration(configurationId: $configurationId) {
      configId
      name
      userType
      scope
      clients {
        accountId
        name
      }
      enabled
      entityId
      idpLoginUrl
      certificate
      idpLogoutUrl
      createdBy {
        name
      }
      updatedBy {
        name
      }
    }
  }
`;

const SSO_ENABLED_CHECK = gql`
  query($userType: String!) {
    isGlobalSsoEnabled(userType: $userType)
  }
`;

const GENERATE_ENTITY_ID = gql`
  query {
    generateSsoConfigEntityId
  }
`;
export {
  GET_SECURITY_CONFIGURATION,
  GET_USER_TFA_DETAIL,
  GET_DEFAULT_PASSWORD_POLICIES,
  NEW_GET_SECURITY_CONFIGURATION,
  GET_ALL_SECURITY_CONFIG,
  SSO_ENABLED_CHECK,
  GET_SECURITY_CONFIG,
  GENERATE_ENTITY_ID
};
